import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

import { BROWSER } from "../constants/settings";
import { parseToken } from "../helpers/auth";
import { baseApi } from "./api/base";
import { UserActions, UserReducer } from "./features/user";

export const store = configureStore({
  reducer: {
    user: UserReducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware),
});

setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

/*
  Auth handlers
*/

if (BROWSER) {
  const token = localStorage.getItem("authToken");
  if (token) {
    try {
      const user = parseToken(token);

      store.dispatch(
        UserActions.setAuthToken({ authToken: token, userData: user }),
      );
    } catch {
      localStorage.removeItem("authToken");
    }
  }

  store.subscribe(() => {
    const { authToken } = store.getState().user;
    if (authToken) {
      localStorage.setItem("authToken", authToken);
    } else {
      localStorage.removeItem("authToken");
    }
  });
}
